import { Box, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import Loading from "../../../../components/Loading/Loading";
import { IoReload } from "react-icons/io5";
import RouteIcon from "@mui/icons-material/Route";
import TerrainIcon from "@mui/icons-material/Terrain";
import MapPreview from "../../../Dashboard/pagesUser/CompleteRoutes/MapPreviewRoute";
import TablePublicRoutes from "./TableRoutesPublic/TableRoutesPublicUser";
import { useSelector } from "react-redux";
import { getAllRoutesPublicAPI } from "../../../../services/rest/routes/routesServices";
import { formatDistance } from "../../../../utils/formatDistance";

const PunlicRoutes = () => {
  const { status } = useSelector((state) => state.userReducer);
  const { membershipStatus } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [previewRouteSelected, setPreviewRouteSelected] = useState({});
  const [refreshing, setRefreshing] = useState(false);
  const navigate = useNavigate();

  const getAllRoutesPublic = useCallback(async () => {
    try {
      if (status !== "active" || membershipStatus !== "active") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );
        return;
      }
      setLoading(true);
      //Se traen las rutas publicas de la API
      const routes = await getAllRoutesPublicAPI();
      // console.log("Rutas publicas", routes);

      setRows(routes);
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `No se pudieron obtener tus rutas en este momento. \n ${message}`
      );
    }
  }, []);

  useEffect(() => {
    getAllRoutesPublic();
  }, [refreshing, getAllRoutesPublic, navigate]);

  return (
    <Box
      sx={{
        paddingLeft: 5,
        paddingRight: 5,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Loading loading={loading} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            gap: 3,
            justifyContent: "center",
          }}
        >
          <Typography variant="h5">Rutas de la comunidad</Typography>
          <IoReload
            className="text-primary fs-4"
            onClick={() => setRefreshing(true)}
          />
        </Box>
      </Box>
      <Box>
        <TablePublicRoutes
          rows={rows}
          setLoading={setLoading}
          setPreviewRouteSelected={setPreviewRouteSelected}
        />
      </Box>
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center" }}
        id="previewMapProvider"
      >
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography className="text-primary fs-2">
            {previewRouteSelected?.nameRoute ?? "Seleccione una ruta"}
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Distancia</Typography>
              </Box>
              <Typography>
                {formatDistance(previewRouteSelected?.distance) ?? 0}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <TerrainIcon className="text-primary " />
                <Typography>Terreno</Typography>
              </Box>
              <Typography>{previewRouteSelected?.terrainType ?? 0}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{ height: 500, width: "100%", borderRadius: 5, overflow: "hidden" }}
      >
        <MapPreview
          coordinates={previewRouteSelected?.coordinates ?? []}
          setLoading={setLoading}
        />
      </Box>
    </Box>
  );
};

export default PunlicRoutes;
